import React from "react";

import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import PropTypes from "prop-types";

import RbInputLabel from "../RbInputLabel";

const RbControl = React.forwardRef(function RbControl(props, ref) {
  const {
    FormHelperTextProps,
    helperText,
    id,
    InputLabelProps,
    label,
    renderComponent,
    ...other
  } = props;

  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const componentProps = {};
  if (id) {
    componentProps.id = id;
    componentProps["aria-describedby"] = id ? `${id}-helper-text` : undefined;
  }

  return (
    <FormControl {...other} ref={ref}>
      {label && (
        <RbInputLabel htmlFor={id} id={inputLabelId} {...InputLabelProps}>
          {label}
        </RbInputLabel>
      )}

      {renderComponent(componentProps)}

      {helperText && (
        <FormHelperText id={helperTextId} {...FormHelperTextProps}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
});

RbControl.propTypes = {
  FormHelperTextProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.node,
  id: PropTypes.string,
  InputLabelProps: PropTypes.object,
  label: PropTypes.node,
  renderComponent: PropTypes.func.isRequired,
};

RbControl.defaultProps = {
  FormHelperTextProps: undefined,
  fullWidth: true,
  helperText: null,
  id: undefined,
  InputLabelProps: undefined,
  label: null,
};

export default RbControl;
